import Vue from 'vue';
import PendoInput from '../../components/input/pendo-input.vue.js';
import PendoIconButton from '../../components/icon-button/pendo-icon-button.vue.js';
import PendoButton from '../../components/button/pendo-button.vue.js';
import isEqual from 'lodash/isEqual.js';

var script = {
  name: 'PendoRepeatingTextInput',
  components: {
    PendoInput,
    PendoIconButton,
    PendoButton
  },
  props: {
    value: {
      type: Array,
      default: () => ['']
    },
    validator: {
      type: Function,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    onlyDelete: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fields: ['']
    };
  },
  computed: {
    disableDelete() {
      return isEqual(this.fields, ['']);
    }
  },
  watch: {
    fields(value) {
      this.$emit('input', value);
    },
    value(value) {
      this.fields = value;
    }
  },
  created() {
    this.fields = this.value;
  },
  methods: {
    removeField(i) {
      this.$emit('removeField', this.fields[i]);
      if (this.fields.length <= 1) {
        this.$emit('addField');
        this.fields = this.onlyDelete ? [] : [''];
      } else {
        this.fields = this.fields.slice(0, i).concat(this.fields.slice(i + 1));
      }
    },
    onInputChange(event) {
      Vue.set(this.fields, event.index, event.value);
    },
    onBlur() {
      if (this.fields[0] !== '' && this.validator(this.fields[0])) {
        this.$emit('domain-changed', this.fields[0]);
      }
    },
    addField() {
      this.fields.push('');
      this.$nextTick(() => {
        this.$refs[`field${this.fields.length - 1}`][0].focus();
      });
      this.$emit('addField');
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-repeating-text-input.vue2.js.map
